var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MantaPrivateWallet, SIGNER_URL, DEFAULT_PULL_SIZE } from './privateWallet';
import Api, { ApiConfig } from './api/index';
import BN from 'bn.js';
/// SbtMantaPrivateWallet class
var SbtMantaPrivateWallet = /** @class */ (function (_super) {
    __extends(SbtMantaPrivateWallet, _super);
    function SbtMantaPrivateWallet(api, wasm, wasmWallet, network, wasmApi, loggingEnabled) {
        return _super.call(this, api, wasm, wasmWallet, network, wasmApi, loggingEnabled, true) || this;
    }
    /// Initializes the SbtMantaPrivateWallet class, for a corresponding environment and network.
    SbtMantaPrivateWallet.initSBT = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var api, _a, wasm, wasmWallet, wasmApi;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, SbtMantaPrivateWallet.initApi(config.environment, config.network, Boolean(config.loggingEnabled))];
                    case 1:
                        api = (_b.sent()).api;
                        return [4 /*yield*/, SbtMantaPrivateWallet.initSBTWasmSdk(api, config)];
                    case 2:
                        _a = _b.sent(), wasm = _a.wasm, wasmWallet = _a.wasmWallet, wasmApi = _a.wasmApi;
                        return [2 /*return*/, new SbtMantaPrivateWallet(api, wasm, wasmWallet, config.network, wasmApi, Boolean(config.loggingEnabled))];
                }
            });
        });
    };
    /// Private helper method for internal use to initialize manta-wasm-wallet for SBT.
    SbtMantaPrivateWallet.initSBTWasmSdk = function (api, config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var wasm, wasmSigner, wasmApiConfig, wasmApi, wasmLedger, wasmWallet;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, import('./wallet/crate/pkg/manta_wasm_wallet')];
                    case 1:
                        wasm = _c.sent();
                        wasmSigner = new wasm.Signer(SIGNER_URL);
                        wasmApiConfig = new ApiConfig(((_a = config.maxReceiversPullSize) !== null && _a !== void 0 ? _a : DEFAULT_PULL_SIZE), ((_b = config.maxSendersPullSize) !== null && _b !== void 0 ? _b : DEFAULT_PULL_SIZE), config.pullCallback, config.errorCallback, Boolean(config.loggingEnabled));
                        wasmApi = new Api(api, wasmApiConfig);
                        wasmLedger = new wasm.SBTPolkadotJsLedger(wasmApi);
                        wasmWallet = new wasm.SBTWallet(wasmLedger, wasmSigner);
                        return [2 /*return*/, {
                                wasm: wasm,
                                wasmWallet: wasmWallet,
                                wasmApi: wasmApi
                            }];
                }
            });
        });
    };
    /// Gets metadata of SBT, corresponds to image
    SbtMantaPrivateWallet.prototype.getSBTMetadata = function (assetId) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, data, asciiHex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkApiIsReady();
                        return [4 /*yield*/, this.api.query.mantaSbt.sbtMetadata(assetId)];
                    case 1:
                        metadata = _a.sent();
                        if (metadata.isNone) {
                            return [2 /*return*/, null];
                        }
                        else {
                            data = metadata.unwrap();
                            asciiHex = data.toString();
                            return [2 /*return*/, hex2a(asciiHex)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /// Builds reserveSbt tx to whitelist to mint SBT
    SbtMantaPrivateWallet.prototype.buildReserveSbt = function (polkadotSigner, polkadotAddress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkApiIsReady();
                        return [4 /*yield*/, this.waitForWallet()];
                    case 1:
                        _a.sent();
                        this.walletIsBusy = true;
                        return [4 /*yield*/, this.setPolkadotSigner(polkadotSigner, polkadotAddress)];
                    case 2:
                        _a.sent();
                        this.walletIsBusy = false;
                        return [2 /*return*/, this.api.tx.mantaSbt.reserveSbt()];
                }
            });
        });
    };
    SbtMantaPrivateWallet.prototype.toHexString = function (byteArray) {
        return byteArray.reduce(function (output, elem) {
            return (output + ('0' + elem.toString(16)).slice(-2));
        }, '');
    };
    SbtMantaPrivateWallet.prototype.buildSbtBatch = function (polkadotSigner, polkadotAddress, startingAssetId, numberOfMints, metadata) {
        return __awaiter(this, void 0, void 0, function () {
            var amount, transactions, transactionDatas, i, transactionUnsigned, networkType, posts_txs, posts, j, convertedPost, transaction, batchTx, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (numberOfMints != metadata.length) {
                            console.error('Number of mints does not correspond to metadata');
                            return [2 /*return*/, null];
                        }
                        this.checkApiIsReady();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 13, , 14]);
                        return [4 /*yield*/, this.waitForWallet()];
                    case 2:
                        _b.sent();
                        this.walletIsBusy = true;
                        return [4 /*yield*/, this.setPolkadotSigner(polkadotSigner, polkadotAddress)];
                    case 3:
                        _b.sent();
                        amount = new BN("1");
                        transactions = [];
                        transactionDatas = [];
                        i = 0;
                        _b.label = 4;
                    case 4:
                        if (!(i < numberOfMints)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.toPrivateBuildUnsigned(startingAssetId, amount)];
                    case 5:
                        transactionUnsigned = _b.sent();
                        startingAssetId = startingAssetId.add(new BN("1"));
                        networkType = this.wasm.Network.from_string("\"".concat(this.network, "\""));
                        return [4 /*yield*/, this.wasmWallet.sign_with_transaction_data(transactionUnsigned, null, networkType)];
                    case 6:
                        posts_txs = _b.sent();
                        posts = posts_txs[0];
                        j = 0;
                        _b.label = 7;
                    case 7:
                        if (!(j < posts.length)) return [3 /*break*/, 10];
                        convertedPost = this.transferPost(posts[j]);
                        return [4 /*yield*/, this.sbtPostToTransaction(convertedPost, this.api, metadata[i])];
                    case 8:
                        transaction = _b.sent();
                        transactions.push(transaction);
                        _b.label = 9;
                    case 9:
                        j++;
                        return [3 /*break*/, 7];
                    case 10:
                        transactionDatas.push(posts_txs[1]);
                        _b.label = 11;
                    case 11:
                        i++;
                        return [3 /*break*/, 4];
                    case 12:
                        this.walletIsBusy = false;
                        batchTx = this.api.tx.utility.batchAll(transactions);
                        return [2 /*return*/, {
                                batchTx: batchTx,
                                transactionDatas: transactionDatas
                            }];
                    case 13:
                        _a = _b.sent();
                        console.error('Unable to build mintSbt transaction');
                        return [2 /*return*/, null];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    SbtMantaPrivateWallet.prototype.sbtPostToTransaction = function (post, api, metadata) {
        return __awaiter(this, void 0, void 0, function () {
            var mintSBT;
            return __generator(this, function (_a) {
                mintSBT = api.tx.mantaSbt.toPrivate(post, metadata);
                return [2 /*return*/, mintSBT];
            });
        });
    };
    /// Produces Identity Proof from randomness in `virtualAsset`
    SbtMantaPrivateWallet.prototype.getIdentityProof = function (virtualAsset, account) {
        return __awaiter(this, void 0, void 0, function () {
            var networkType, asset, account_id, identityProof, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.waitForWallet()];
                    case 1:
                        _a.sent();
                        this.walletIsBusy = true;
                        networkType = this.wasm.Network.from_string("\"".concat(this.network, "\""));
                        asset = this.wasm.VirtualAsset.from_string(virtualAsset);
                        account_id = this.wasm.Account.from_string(account);
                        identityProof = this.wasmWallet.identity_proof(asset, account_id, networkType);
                        this.walletIsBusy = false;
                        return [2 /*return*/, identityProof];
                    case 2:
                        e_1 = _a.sent();
                        this.walletIsBusy = false;
                        console.error('Failed to build Identity Proof.', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return SbtMantaPrivateWallet;
}(MantaPrivateWallet));
export { SbtMantaPrivateWallet };
// convert hex to ascii string starts with 0x
function hex2a(hex) {
    var str = '';
    for (var i = 2; i < hex.length; i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
}
